import React, { useState } from "react";
import { cn } from "@/lib/utils";

const AuthSwitch = ({
  mobile,
  styles,
  selected,
  setSelected,
}: {
  mobile?: boolean;
  styles?: string;
  selected: "register" | "login";
  setSelected: React.Dispatch<React.SetStateAction<"register" | "login">>;
}) => {
  return (
    <div
      className={cn(
        "relative flex h-[42px] rounded-[17px] bg-white/[0.05] p-[2px] text-[14px] onest-smb",
        styles && styles
      )}
    >
      <div
        className={`absolute top-[2px] h-[38px] w-[calc(50%-2px)] rounded-[15px] bg-white transition-all ${
          selected === "login" ? "left-1/2" : "left-[2px]"
        }`}
      />
      <button
        className={`w-full relative px-[12px] py-[10px] transition-all ${
          selected === "register" ? "text-black" : "text-white"
        }`}
        onClick={(e) => {
          e.preventDefault();
          setSelected("register");
        }}
      >
        Register
      </button>
      <button
        className={`w-full relative px-[12px] py-[10px] transition-all ${
          selected === "login" ? "text-black" : "text-white"
        }`}
        onClick={(e) => {
          e.preventDefault();
          setSelected("login");
        }}
      >
        Log in
      </button>
    </div>
  );
};

export default AuthSwitch;
